import { AtomKey } from '../_constants';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export interface TicketVM {
  freeTicketIds: number[];
  freeTicketCount: number;
}

const localStorage =
  typeof window !== 'undefined' ? window.localStorage : undefined;

const { persistAtom } = recoilPersist({
  key: AtomKey.USER_TIKET,
  storage: localStorage,
});

export const TicketState = atom<TicketVM>({
  key: AtomKey.USER_TIKET,
  default: { freeTicketIds: [], freeTicketCount: 0 },
  effects_UNSTABLE: [persistAtom],
});
